// Checked
import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import LinearProgress from "@material-ui/core/LinearProgress";

import { useSnackbar } from "notistack";
import Slide from "@material-ui/core/Slide";

import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { Link, useHistory, useLocation } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import RefreshToken from "../../components/RefreshToken";
import { TransferContext } from "../../context/TransferContext";
const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
    background: "white",
    borderRadius: "5px",
    boxShadow: "0px 0px 2px 1px rgba(0, 0, 0, .05)",
    marginBottom: "40px",
  },
  marginBottomStyle: {
    marginBottom: "20px",
  },
  rightAlign: {
    textAlign: "right",
  },
  buttonStyle: {
    padding: "10px 32px",
    fontSize: "16px",
    color: "white",
    fontWeight: 600,
    textTransform: "capitalize",
    borderRadius: "8px",
    boxShadow: "none",
    "&:hover": {
      boxShadow: "none",
    },
  },
  inputStyle: {
    borderRadius: "8px",
  },

  cssLabel: {
    color: "blue",
    background: "red",

    "&.Mui-focused": {
      position: "absolute",
      top: 10,
      color: "red",
      background: "red",
    },
  },

  cssFocused: {
    color: "blue",
    background: "red",

    "&.Mui-focused": {
      color: "red",
      background: "red",
    },
  },
  inputStyle2: {
    borderRadius: "8px",
    // "& .MuiInputBase-input": {
    //   color: "#A2A2A2",
    // },

    "& .MuiSelect-outlined.MuiSelect-outlined": {
      fontSize: "14px",
      padding: 13,
    },
    "& .MuiSelect-select:focus": {
      backgroundColor: "#fff",
    },
  },

  textField: {
    [`& fieldset`]: {
      borderRadius: 8,
    },
    "& .MuiOutlinedInput-input": {
      fontSize: "14px",
    },
    "& .MuiOutlinedInput-inputMarginDense": {
      padding: 13,
    },
  },
  selectStyle: {
    textAlign: "left",
    "& .MuiSelect-select:focus": {
      backgroundColor: "#fff",
    },
    "& img": {
      position: "relative",
      top: "2px",
      marginRight: "5px",
    },
  },
  inputRoot: {
    "& .MuiOutlinedInput-input": {
      // color: "green",
      // fontWeight: 600,
    },
    "& .MuiInputLabel-root": {
      // color: "green",
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      // borderColor: "#eee",
      // backgroundColor: "#eee",
      color: "#333",
    },
    "&:hover .MuiOutlinedInput-input": {
      // color: "red",
    },
    "&:hover .MuiInputLabel-root": {
      // color: "red",
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      // borderColor: "red",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
      // color: "purple",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      // color: "purple",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      // borderColor: "purple",
    },
  },
  flag: {
    marginRight: 10,
    width: 20,
    position: "relative",
    top: 4,
  },
  select: {
    "& .MuiSelect-select:focus": {
      backgroundColor: "#fff",
      borderWidth: 0,
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#fff",
    },
    padding: "5px",
    height: 45,
    borderRadius: 8,
  },
  placeholder: {
    color: "#999",
  },
}));
const CashDelivery = () => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [countries, setCountries] = useState([]);
  const [originCountry, setOriginCountry] = useState("");
  const [destinationCountry, setDestinationCountry] = useState("");
  const [toFlag, seTtoFlag] = useState("");
  const [transactionNumber, setTransactionNumber] = useState("");
  const [phoneCode, setPhoneCode] = useState("na");
  const [phone, setPhone] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const { login, glob_pay_agent_auth, logout } = useContext(AuthContext);

  const { removeTransfer } = useContext(TransferContext);

  const { enqueueSnackbar } = useSnackbar();

  const handleCountry = (e) => {
    setOriginCountry(e.target.value);
  };

  const getCountries = async () => {
    setLoading(true);
    try {
      let res = await axios({
        url: "/api/v1/public/countries",
        method: "get",
      });

      setCountries(res.data.data);

      if (location.state) {
        let origin = res.data.data.filter(
          (e) => e.name === location.state.destinationCountry
        );
        setPhoneCode(origin[0].code);
        setPhone(origin[0].phone);
      }

      console.log("country", res.data.data);
    } catch (error) {
      console.log("err", error.response);
    }
    setLoading(false);
  };

  const HandleMobileNumber = (e) => {
    setMobileNumber(e.target.value);
  };

  const handlePhoneCode = (e) => {
    let value = e.target.value;
    let myValue = countries.filter((event) => event.code === value);
    console.log("new", myValue);
    setPhoneCode(myValue[0].code);
    setPhone(myValue[0].phone);
  };

  const handleSendOtp = async (e) => {
    e.preventDefault();
    setLoading(true);
    let token = await RefreshToken(glob_pay_agent_auth, logout, login);

    let data = {
      transactionNumber,
      originCountry,
      mobileNumber: `${phone}${mobileNumber}`,
    };

    try {
      let res = await axios({
        url: `/api/v1/private/cashout/send-otp`,
        method: "post",
        data: data,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log("send top", res.data.data);

      enqueueSnackbar(res.data.message, {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "success",
        TransitionComponent: Slide,
      });

      history.push({ pathname: "/receiver-authentication", state: data });
    } catch (error) {
      console.log("err:::", error.response);

      let er = error.response && error.response.data.errors.toString();

      enqueueSnackbar(er, {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "error",
        TransitionComponent: Slide,
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    removeTransfer({});
    getCountries();

    if (location.state) {
      setTransactionNumber(location.state.transactionNumber);
      setOriginCountry(location.state.originCountry);
    }
  }, []);

  return (
    <>
      {loading ? <LinearProgress /> : null}

      <div className={classes.root}>
        <Typography variant="h5" className={classes.marginBottomStyle}>
          Enter Transaction Information
        </Typography>
        <form onSubmit={handleSendOtp}>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            spacing={3}
          >
            <Grid item xs={3}>
              <Typography variant="body1"> Transaction ID</Typography>
            </Grid>
            <Grid item xs={9}>
              <TextField
                id="transaction-id"
                size="small"
                fullWidth
                placeholder="Enter ID number"
                variant="outlined"
                required
                className={classes.textField}
                value={transactionNumber}
                onChange={(e) => setTransactionNumber(e.target.value)}
              />
            </Grid>
            <Grid item xs={3}>
              <Typography variant="body1">Country of Origin</Typography>
            </Grid>
            <Grid item xs={9}>
              <FormControl variant="outlined" size="small" fullWidth>
                {/* <InputLabel id="demo-simple-select-label">Country of Origin</InputLabel> */}
                <Select
                  labelId="country-select-outlined-label"
                  id="country-select-outlined"
                  required
                  onChange={handleCountry}
                  className={classes.inputStyle2}
                  value={originCountry}
                  InputLabelProps={{
                    classes: {
                      root: classes.cssLabel,
                      focused: classes.cssFocused,
                    },
                  }}
                  displayEmpty
                >
                  <MenuItem disabled value="">
                    <span style={{ color: "#999" }}>Select Country</span>
                  </MenuItem>

                  {countries.map((e, index) => (
                    <MenuItem
                      key={index}
                      value={e.name}
                      className={classes.selectItemStyle}
                    >
                      <img src={e.flag} alt="" className={classes.flag} />
                      {e.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={3}>
              <Typography variant="body1">Mobile Number</Typography>
            </Grid>

            <Grid item xs={2}>
              <FormControl
                variant="outlined"
                className={classes.formControl}
                fullWidth
              >
                <TextField
                  displayEmpty
                  className={classes.inputRoot}
                  value={phoneCode}
                  onChange={handlePhoneCode}
                  variant="outlined"
                  required
                  defaultValue="na"
                  select
                  InputProps={{
                    className: classes.select,
                  }}
                  size="small"
                >
                  <MenuItem value="na" disabled>
                    <span style={{ color: "#999" }}>Select Code</span>
                  </MenuItem>
                  {countries.map((item, index) => (
                    <MenuItem value={item.code} key={index}>
                      <img src={item.flag} alt="" className={classes.flag} />
                      {item.phone}
                    </MenuItem>
                  ))}
                </TextField>
              </FormControl>
            </Grid>
            <Grid item xs={7}>
              <TextField
                id="number"
                size="small"
                fullWidth
                variant="outlined"
                required
                placeholder="Enter Mobile Number"
                className={classes.textField}
                value={mobileNumber}
                onChange={HandleMobileNumber}
              />
            </Grid>
            <Grid item xs={12} className={classes.rightAlign}>
              <Button
                variant="contained"
                color="primary"
                className={classes.buttonStyle}
                type="submit"
              >
                Continue
              </Button>
            </Grid>
          </Grid>
        </form>
      </div>
    </>
  );
};
export default CashDelivery;
